import * as React from 'react';
import {TabActions, CommonActions} from '@react-navigation/native';

// import PropTypes from 'prop-types';

export const navigationRef = React.createRef();

export function navigate(navName, screenName, internalScreen) {
  if (navigationRef?.current?.isReady()) {
    navigationRef.current?.push(navName, {
      screen: screenName,
      params: {screen: internalScreen},
    });
  }
}

export function navigateWithNavigation(screenName, params) {
  if (navigationRef?.current?.isReady()) {
    const navigateAction = CommonActions.navigate({
      name: screenName,
      params,
    });
    navigationRef?.current?.dispatch(navigateAction);
  }
}

export function navigationReset() {
  if (navigationRef?.current?.isReady()) {
    navigationRef?.current?.dispatch(
      CommonActions.reset({
        index: 0,
        routes: [{name: 'Home'}],
      }),
    );
  }

  //const jumpToAction = TabActions.jumpTo('Markets');
  // navigationRef.current.dispatch(jumpToAction);
}

export function getCurrentRoute() {
  if (navigationRef?.current?.isReady()) {
    const route = navigationRef.current.getCurrentRoute();

    return route.name;
  }
}
